import { FETCH_GET, FETCH_POST } from "../../config";
import { push } from "react-router-redux";
import { addFlashMessage } from "./flashMessage";
import { mergeGuestCart, syncCartToBackend } from "../../utils/cartSync";

export const CREATE_CUSTOMER_PENDING = "CREATE_CUSTOMER_PENDING";
export const CREATE_CUSTOMER_FULFILLED = "CREATE_CUSTOMER_FULFILLED";
export const CREATE_CUSTOMER_REJECTED = "CREATE_CUSTOMER_REJECTED";

export const LOGIN_CUSTOMER_PENDING = "LOGIN_CUSTOMER_PENDING";
export const LOGIN_CUSTOMER_FULFILLED = "LOGIN_CUSTOMER_FULFILLED";
export const LOGIN_CUSTOMER_REJECTED = "LOGIN_CUSTOMER_REJECTED";

export const LOGOUT_CUSTOMER = "LOGOUT_CUSTOMER";

export const ADD_NEW_ADDRESS_PENDING = "ADD_NEW_ADDRESS_PENDING";
export const ADD_NEW_ADDRESS_FULFILLED = "ADD_NEW_ADDRESS_FULFILLED";
export const ADD_NEW_ADDRESS_REJECTED = "ADD_NEW_ADDRESS_REJECTED";

export const EDIT_ADDRESS_PENDING = "EDIT_ADDRESS_PENDING";
export const EDIT_ADDRESS_FULFILLED = "EDIT_ADDRESS_FULFILLED";
export const EDIT_ADDRESS_REJECTED = "EDIT_ADDRESS_REJECTED";

export const GET_ADDRESS_PENDING = "GET_ADDRESS_PENDING";
export const GET_ADDRESS_FULFILLED = "GET_ADDRESS_FULFILLED";
export const GET_ADDRESS_REJECTED = "GET_ADDRESS_REJECTED";

export const GET_PROFILE_INFO_PENDING = "GET_PROFILE_INFO_PENDING";
export const GET_PROFILE_INFO_FULFILLED = "GET_PROFILE_INFO_FULFILLED";
export const GET_PROFILE_INFO_REJECTED = "GET_PROFILE_INFO_REJECTED";

export const UPDATE_PROFILE_PENDING = "UPDATE_PROFILE_PENDING";
export const UPDATE_PROFILE_FULFILLED = "UPDATE_PROFILE_FULFILLED";
export const UPDATE_PROFILE_REJECTED = "UPDATE_PROFILE_REJECTED";

export const UPDATE_PASSWORD_PENDING = "UPDATE_PASSWORD_PENDING";
export const UPDATE_PASSWORD_FULFILLED = "UPDATE_PASSWORD_FULFILLED";
export const UPDATE_PASSWORD_REJECTED = "UPDATE_PASSWORD_REJECTED";

export const UPDATE_ADDRESS_ACTIVE_PENDING = "UPDATE_ADDRESS_ACTIVE_PENDING";
export const UPDATE_ADDRESS_ACTIVE_FULFILLED =
  "UPDATE_ADDRESS_ACTIVE_FULFILLED";
export const UPDATE_ADDRESS_ACTIVE_REJECTED = "UPDATE_ADDRESS_ACTIVE_REJECTED";

export const REMOVE_ADDRESS_PENDING = "REMOVE_ADDRESS_PENDING";
export const REMOVE_ADDRESS_FULFILLED = "REMOVE_ADDRESS_FULFILLED";
export const REMOVE_ADDRESS_REJECTED = "REMOVE_ADDRESS_REJECTED";

export const FORGOT_PASSWORD_PENDING = "FORGOT_PASSWORD_PENDING";
export const FORGOT_PASSWORD_FULFILLED = "FORGOT_PASSWORD_FULFILLED";
export const FORGOT_PASSWORD_REJECTED = "FORGOT_PASSWORD_REJECTED";

export const RESET_PASSWORD_PENDING = "RESET_PASSWORD_PENDING";
export const RESET_PASSWORD_FULFILLED = "RESET_PASSWORD_FULFILLED";
export const RESET_PASSWORD_REJECTED = "RESET_PASSWORD_REJECTED";

export const resetPasswordCustomer = ({ email, password, token, tokenID }) => {
  const query = `mutation($email:String,$password:String,$forgotKey:String,$tokenID:String){resetPasswordCustomer(email:$email,password:$password,forgotKey:$forgotKey,tokenID:$tokenID)}`;
  const variables = JSON.stringify({
    email,
    password,
    forgotKey: token,
    tokenID,
  });
  return async (dispatch) => {
    dispatch({ type: RESET_PASSWORD_PENDING });
    try {
      const result = await FETCH_POST({ query, variables });
      if (result.data.errors) {
        dispatch({
          type: RESET_PASSWORD_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: RESET_PASSWORD_FULFILLED,
          payload: result.data.data.resetPasswordCustomer,
        });
      }
    } catch (e) {
      dispatch({
        type: RESET_PASSWORD_REJECTED,
        payload: [{ message: e.toString() }],
      });
    }
  };
};

export const forgotCustomer = ({ email }) => {
  const query = `mutation($email:String){forgotCustomer(email:$email)}`;
  const variables = JSON.stringify({ email });
  return async (dispatch) => {
    dispatch({ type: FORGOT_PASSWORD_PENDING });
    try {
      const result = await FETCH_POST({ query, variables });
      if (result.data.errors) {
        dispatch({
          type: FORGOT_PASSWORD_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: FORGOT_PASSWORD_FULFILLED,
          payload: result.data.data.forgotCustomer,
        });
      }
    } catch (e) {
      dispatch({
        type: FORGOT_PASSWORD_REJECTED,
        payload: [{ message: e.toString() }],
      });
    }
  };
};

export const removeAddress = (id) => {
  const query = `mutation($id:ID){removeAddress(id:$id){addresses{id,first_name,last_name,postal_code,city,town,address,address_name,phone,active,invoice_type,company_name,tax_number,tax_office}}}`;
  const variables = JSON.stringify({ id });
  return async (dispatch) => {
    dispatch({ type: REMOVE_ADDRESS_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_POST({ query, variables }, token);
        if (result.data.errors) {
          dispatch({
            type: REMOVE_ADDRESS_REJECTED,
            payload: result.data.errors,
          });
          dispatch(
            addFlashMessage({
              type: "danger",
              title: "Bir Hata Meydana Geldi",
              messages: result.data.errors.map((v) => v.message),
            })
          );
        } else {
          dispatch({
            type: REMOVE_ADDRESS_FULFILLED,
            payload: result.data.data.removeAddress.addresses,
          });
        }
      } catch (e) {
        dispatch({
          type: REMOVE_ADDRESS_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const updateActiveAddress = (id) => {
  const query = `mutation($id:ID){updateActiveAddress(id:$id){addresses{id,first_name,last_name,postal_code,city,town,address,address_name,phone,active,invoice_type,company_name,tax_number,tax_office}}}`;
  const variables = JSON.stringify({ id });
  return async (dispatch) => {
    dispatch({ type: UPDATE_ADDRESS_ACTIVE_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_POST({ query, variables }, token);
        if (result.data.errors) {
          dispatch({
            type: UPDATE_ADDRESS_ACTIVE_REJECTED,
            payload: result.data.errors,
          });
          dispatch(
            addFlashMessage({
              type: "danger",
              title: "Bir Hata Meydana Geldi",
              messages: result.data.errors.map((v) => v.message),
            })
          );
        } else {
          dispatch({
            type: UPDATE_ADDRESS_ACTIVE_FULFILLED,
            payload: result.data.data.updateActiveAddress.addresses,
          });
        }
      } catch (e) {
        dispatch({
          type: UPDATE_ADDRESS_ACTIVE_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const customerEditPassword = ({ password, old_password }) => {
  const query = `mutation($input:customerEditPasswordInput){customerEditPassword(input:$input){id}}`;
  const variables = JSON.stringify({
    input: {
      password,
      old_password,
    },
  });
  return async (dispatch) => {
    dispatch({ type: UPDATE_PASSWORD_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_POST({ query, variables }, token);
        if (result.data.errors) {
          dispatch({
            type: UPDATE_PASSWORD_REJECTED,
            payload: result.data.errors,
          });
          dispatch(
            addFlashMessage({
              type: "danger",
              title: "Bir Hata Meydana Geldi",
              messages: result.data.errors.map((v) => v.message),
            })
          );
        } else {
          dispatch({
            type: UPDATE_PASSWORD_FULFILLED,
            payload: result.data.data.customerEditPassword,
          });
          dispatch(
            push({
              pathname: "/hesabim",
              state: {
                flashMessage: {
                  type: "success",
                  title: "Şifreniz Başarıyla Düzenlendi.",
                },
              },
            })
          );
        }
      } catch (e) {
        dispatch({
          type: UPDATE_PASSWORD_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const updateProfile = ({ full_name, email, phone }) => {
  const query = `mutation($input:editCustomerInput){customerUpdateProfile(input:$input){id,full_name,email,phone}}`;
  const variables = JSON.stringify({
    input: {
      full_name,
      email,
      phone,
    },
  });

  return async (dispatch) => {
    dispatch({ type: UPDATE_PROFILE_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_POST({ query, variables }, token);
        if (result.data.errors) {
          dispatch({
            type: UPDATE_PROFILE_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: UPDATE_PROFILE_FULFILLED,
            payload: result.data.data.customerUpdateProfile,
          });
          dispatch(me());
          dispatch(
            push({
              pathname: "/hesabim",
              state: {
                flashMessage: {
                  type: "success",
                  title: "Profiliniz Başarıyla Düzenlendi.",
                },
              },
            })
          );
        }
      } catch (e) {
        dispatch({
          type: UPDATE_PROFILE_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const getProfileInfo = (success) => {
  const query = `query={getProfileInfo{id,full_name,email,phone}}`;
  return async (dispatch) => {
    dispatch({ type: GET_PROFILE_INFO_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_GET(query, token);
        if (result.data.errors) {
          dispatch({
            type: GET_PROFILE_INFO_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: GET_PROFILE_INFO_FULFILLED,
            payload: result.data.data.getProfileInfo,
          });
          success(result.data.data.getProfileInfo);
          // dispatch(push("/"));
        }
      } catch (e) {
        dispatch({
          type: GET_PROFILE_INFO_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      // dispatch({
      //   type: GET_PROFILE_INFO_REJECTED,
      //   payload: [{ message: "Giriş Yapılmamış." }]
      // });
      // dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const customerGetAddress = (success) => {
  const query = `query={customerGetAddress{addresses{id,first_name,last_name,postal_code,city,town,address,address_name,phone,active,invoice_type,company_name,tax_number,tax_office}}}`;
  return async (dispatch) => {
    dispatch({ type: GET_ADDRESS_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_GET(query, token);
        if (result.data.errors) {
          dispatch({
            type: GET_ADDRESS_REJECTED,
            payload: result.data.errors,
          });
        } else {
          // Backend'den gelen adreslerde id alanının olduğundan emin ol
          const addresses = result.data.data.customerGetAddress.addresses.map(
            (addr) => {
              // Eğer id yoksa _id kullan (MongoDB'den gelen veri)
              if (!addr.id && addr._id) {
                return { ...addr, id: addr._id };
              }
              return addr;
            }
          );

          dispatch({
            type: GET_ADDRESS_FULFILLED,
            payload: addresses,
          });

          // Aktif adres özelliği kaldırıldı - ilk adresi döndür
          success(addresses.length > 0 ? addresses[0].id : null);
        }
      } catch (e) {
        dispatch({
          type: GET_ADDRESS_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const editAddress = (
  {
    id,
    first_name,
    last_name,
    city,
    town,
    postal_code,
    address,
    phone,
    address_name,
    invoice_type,
    company_name,
    tax_number,
    tax_office,
  },
  callback
) => {
  const query = `mutation($input:editAddressInput){editAddress(input:$input){addresses{id,first_name,last_name,postal_code,city,town,address,address_name,phone,active,invoice_type,company_name,tax_number,tax_office}}}`;
  const variables = JSON.stringify({
    input: {
      id,
      first_name,
      last_name,
      city,
      town,
      postal_code,
      address,
      phone,
      address_name,
      invoice_type,
      company_name,
      tax_number,
      tax_office,
    },
  });
  return async (dispatch) => {
    dispatch({ type: EDIT_ADDRESS_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_POST({ query, variables }, token);

        if (result.data.errors) {
          dispatch({
            type: EDIT_ADDRESS_REJECTED,
            payload: result.data.errors,
          });
          dispatch(
            addFlashMessage({
              type: "danger",
              title: "Bir Hata Meydana Geldi",
              messages: result.data.errors.map((v) => v.message),
            })
          );
        } else {
          dispatch({
            type: EDIT_ADDRESS_FULFILLED,
            payload: result.data.data.editAddress.addresses,
          });
          dispatch(
            addFlashMessage({
              type: "success",
              title: "Adres başarıyla düzenlendi.",
            })
          );
          // dispatch(push("/"));
        }
        if (callback) callback();
      } catch (e) {
        dispatch({
          type: EDIT_ADDRESS_REJECTED,
          payload: [{ message: e.toString() }],
        });
        dispatch(
          addFlashMessage({
            type: "danger",
            title: "Bir Hata Meydana Geldi",
            messages: [{ message: e.toString() }],
          })
        );
        if (callback) callback();
      }
    } else {
      dispatch(push("/giris-yap"));

      // TODO: login sayfasına yönlendir!
    }
  };
};

// updateAddress alias for editAddress (backward compatibility)
export const updateAddress = editAddress;

export const addNewAddress = ({
  first_name,
  last_name,
  city,
  town,
  postal_code,
  address,
  phone,
  address_name,
  invoice_type,
  company_name,
  tax_number,
  tax_office,
}) => {
  const query = `mutation($input:createAddressInput){addNewAddress(input:$input){addresses{id,first_name,last_name,postal_code,city,town,address,address_name,phone,active,invoice_type,company_name,tax_number,tax_office}}}`;
  const variables = JSON.stringify({
    input: {
      first_name,
      last_name,
      city,
      town,
      postal_code,
      address,
      phone,
      address_name,
      invoice_type,
      company_name,
      tax_number,
      tax_office,
    },
  });
  return async (dispatch) => {
    dispatch({ type: ADD_NEW_ADDRESS_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_POST({ query, variables }, token);

        if (result.data.errors) {
          dispatch({
            type: ADD_NEW_ADDRESS_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: ADD_NEW_ADDRESS_FULFILLED,
            payload: result.data.data.addNewAddress.addresses,
          });
          // dispatch(push("/"));
        }
      } catch (e) {
        dispatch({
          type: ADD_NEW_ADDRESS_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));

      // TODO: login sayfasına yönlendir!
    }
  };
};

export const logOut = () => {
  return (dispatch) => {
    localStorage.removeItem("token");
    dispatch({ type: LOGOUT_CUSTOMER });
    dispatch(push("/"));
  };
};

export const me = (callback) => {
  const query = `query={me{id,full_name,email,discount_enabled,discount_type,discount_value,min_cart_amount}}`;
  return async (dispatch) => {
    dispatch({ type: LOGIN_CUSTOMER_PENDING });
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const result = await FETCH_GET(query, token);

        if (result.data.errors) {
          dispatch({
            type: LOGIN_CUSTOMER_REJECTED,
            payload: result.data.errors,
          });
          if (callback) callback();
        } else {
          const customer = result.data.data.me;
          dispatch({
            type: LOGIN_CUSTOMER_FULFILLED,
            payload: customer,
          });

          // Merge guest cart to customer cart after successful login
          try {
            await mergeGuestCart(customer.id);
          } catch (error) {
            console.error("[Auth] Failed to merge guest cart:", error);
          }

          if (callback) callback();
          // dispatch(push("/"));
        }
      } catch (e) {
        dispatch({
          type: LOGIN_CUSTOMER_REJECTED,
          payload: [{ message: e.toString() }],
        });
        localStorage.removeItem("token");
        if (callback) callback();
      }
    } else {
      // dispatch({
      //   type: LOGIN_CUSTOMER_REJECTED,
      //   payload: [{ message: "Giriş Yapılmamış" }]
      // });
      // dispatch(push("/giris-yap"));

      // TODO: login sayfasına yönlendir!
      if (callback) callback();
    }
  };
};

export const loginCustomer = ({ email, password }, location = "/") => {
  const query = `mutation($email:String!,$password:String!){loginCustomer(email:$email,password:$password)}`;
  const variables = JSON.stringify({ email, password });
  return async (dispatch) => {
    dispatch({ type: LOGIN_CUSTOMER_PENDING });
    try {
      const result = await FETCH_POST({ query, variables });
      if (result.data.errors) {
        dispatch({
          type: LOGIN_CUSTOMER_REJECTED,
          payload: result.data.errors,
        });
      } else {
        localStorage.setItem("token", result.data.data.loginCustomer);
        dispatch(me());
        dispatch(push(location));
      }
    } catch (e) {
      dispatch({
        type: LOGIN_CUSTOMER_REJECTED,
        payload: [{ message: e.toString() }],
      });
    }
  };
};

export const createCustomer = (
  { full_name, email, phone, password },
  location = "/"
) => {
  const query = `mutation($input:createCustomerInput){createCustomer(input:$input)}`;
  const variables = JSON.stringify({
    input: {
      full_name,
      email,
      phone,
      password,
    },
  });
  return async (dispatch) => {
    dispatch({ type: CREATE_CUSTOMER_PENDING });
    try {
      const result = await FETCH_POST({ query, variables });
      if (result.data.errors) {
        dispatch({
          type: CREATE_CUSTOMER_REJECTED,
          payload: result.data.errors,
        });
      } else {
        localStorage.setItem("token", result.data.data.createCustomer);
        dispatch(me());
        dispatch(push(location));
        // dispatch({
        //   type: CREATE_CUSTOMER_FULFILLED,
        //   payload: result.data.data.createCustomer
        // });
        // // TODO: Müşteri kayıt oldu şimdi login ettir ve ilgili sayfaya yönlendir
        // dispatch(push("/"));
      }
    } catch (e) {
      dispatch({
        type: CREATE_CUSTOMER_REJECTED,
        payload: [{ message: e.toString() }],
      });
    }
  };
};

// export const getProduct = ({ id }) => {
//   const query = `query={getProduct(id:"${id}"){id,name,
//   content,
//   meta_title,
//   meta_description,
//   meta_keywords,
//   active,
//   categories{id,title},
//   image,
//   images,
//   stock,
//   price,
//   sale_price,
//   stock_status,
//   shipping,
//   shipping_price}}`;
//   return async (dispatch, getState) => {
//     dispatch({ type: FETCH_PRODUCT_PENDING });
//     const data = getState().product.productList.find(v => v.id === id);
//     if (data) {
//       dispatch({
//         type: FETCH_PRODUCT_FULFILLED,
//         payload: data
//       });
//     } else {
//       try {
//         const result = await FETCH_GET(query);
//         if (result.data.errors) {
//           dispatch(
//             addFlashMessage({
//               type: "danger",
//               title: "Bir Hata Meydana Geldi",
//               messages: result.data.errors.map(v => v.message)
//             })
//           );
//           dispatch({
//             type: FETCH_PRODUCT_REJECTED,
//             payload: result.data.errors
//           });
//         } else {
//           dispatch({
//             type: FETCH_PRODUCT_FULFILLED,
//             payload: result.data.data.getProduct
//           });
//         }
//       } catch (e) {
//         dispatch(
//           addFlashMessage({
//             type: "danger",
//             title: "Bir Hata Meydana Geldi",
//             messages: [e.toString()]
//           })
//         );
//         dispatch({ type: FETCH_PRODUCT_REJECTED });
//       }
//     }
//   };
// };
//
// export const fetchAllProducts = () => {
//   const query = `query={allProducts{
//     id,name,
//     content,
//     meta_title,
//     meta_description,
//     meta_keywords,
//     active,
//     categories{id,title},
//     image,
//     images,
//     stock,
//     price,
//     sale_price,
//     stock_status,
//     shipping,
//     shipping_price
//   }}`;
//   return async dispatch => {
//     dispatch({ type: FETCH_ALL_PRODUCT_PENDING });
//     try {
//       const result = await FETCH_GET(query);
//       if (result.data.errors) {
//         dispatch(
//           addFlashMessage({
//             type: "danger",
//             title: "Bir Hata Meydana Geldi",
//             messages: result.data.errors.map(v => v.message)
//           })
//         );
//         dispatch({
//           type: FETCH_ALL_PRODUCT_REJECTED,
//           payload: result.data.errors
//         });
//       } else {
//         dispatch({
//           type: FETCH_ALL_PRODUCT_FULFILLED,
//           payload: result.data.data.allProducts
//         });
//       }
//     } catch (e) {
//       dispatch(
//         addFlashMessage({
//           type: "danger",
//           title: "Bir Hata Meydana Geldi",
//           messages: [e.toString()]
//         })
//       );
//       dispatch({ type: FETCH_ALL_PRODUCT_REJECTED });
//     }
//   };
// };
//
// export const deleteProduct = ({ id }) => {
//   const query = `mutation($id:ID!){deleteProduct(id:$id)}`;
//   const variables = JSON.stringify({ id });
//
//   return async dispatch => {
//     dispatch({ type: DELETE_PRODUCT_PENDING });
//     try {
//       const result = await FETCH_POST({ query, variables });
//       if (result.data.errors) {
//         dispatch(
//           addFlashMessage({
//             type: "danger",
//             title: "Bir Hata Meydana Geldi1",
//             messages: result.data.errors.map(v => v.message)
//           })
//         );
//         dispatch({
//           type: DELETE_PRODUCT_REJECTED,
//           payload: result.data.errors
//         });
//       } else {
//         dispatch({
//           type: DELETE_PRODUCT_FULFILLED,
//           payload: id
//         });
//         dispatch(
//           push({
//             pathname: "/products",
//             state: {
//               flashMessage: {
//                 type: "success",
//                 title: "Başarıyla Silindi"
//               }
//             }
//           })
//         );
//       }
//     } catch (e) {
//       dispatch(
//         addFlashMessage({
//           type: "danger",
//           title: "Bir Hata Meydana Geldi2",
//           messages: [e.toString()]
//         })
//       );
//       dispatch({ type: DELETE_PRODUCT_REJECTED });
//     }
//   };
// };
//
// export const createProduct = ({
//   name,
//   content,
//   meta_title,
//   meta_description,
//   meta_keywords,
//   active,
//   categories,
//   image,
//   images,
//   stock,
//   price,
//   sale_price,
//   stock_status,
//   shipping,
//   shipping_price
// }) => {
//   const query = `mutation($input:createProductInput){createProduct(input:$input){id,name,
//   content,
//   meta_title,
//   meta_description,
//   meta_keywords,
//   active,
//   categories{id,title},
//   image,
//   images,
//   stock,
//   price,
//   sale_price,
//   stock_status,
//   shipping,
//   shipping_price}}`;
//   const variables = JSON.stringify({
//     input: {
//       name,
//       content,
//       meta_title,
//       meta_description,
//       meta_keywords,
//       active,
//       categories,
//       image,
//       images,
//       stock,
//       price,
//       sale_price,
//       stock_status,
//       shipping,
//       shipping_price
//     }
//   });
//
//   return async dispatch => {
//     dispatch({ type: CREATE_PRODUCT_PENDING });
//     try {
//       const result = await FETCH_POST({ query, variables });
//       if (result.data.errors) {
//         dispatch(
//           addFlashMessage({
//             type: "danger",
//             title: "Bir Hata Meydana Geldi",
//             messages: result.data.errors.map(v => v.message)
//           })
//         );
//         dispatch({
//           type: CREATE_PRODUCT_REJECTED,
//           payload: result.data.errors
//         });
//       } else {
//         dispatch({
//           type: CREATE_PRODUCT_FULFILLED,
//           payload: result.data.data.createProduct
//         });
//         dispatch(
//           push({
//             pathname: "/products",
//             state: {
//               flashMessage: {
//                 type: "success",
//                 title: "Başarıyla Kaydedildi"
//               }
//             }
//           })
//         );
//       }
//     } catch (e) {
//       dispatch(
//         addFlashMessage({
//           type: "danger",
//           title: "Bir Hata Meydana Geldi",
//           messages: [e.toString()]
//         })
//       );
//       dispatch({ type: CREATE_PRODUCT_REJECTED });
//     }
//   };
// };



// WEBPACK FOOTER //
// ./src/store/actions/customer.js